
jQuery.ajaxSettings.traditional = true;

app.service('orderInit', function (order, dispatcher, html, callback) {
	var isInit = false;
	function init() {
		if (!isInit) {
			isInit = true;
			callback.run('beforeInit');
			UA.init();
			dispatcher.init();
			order.init();
			html.add('page-init');
			callback.run('afterInit');
		}
	}
	$().ready(function () {
		init();
	});
});
